import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HospitalDashboardTask } from 'src/app/leader-toolkit/models/hospital-dashboard.model';

@Component({
  selector: 'vc-hospital-tasks-card',
  templateUrl: './hospital-tasks-card.component.html',
  styleUrl: './hospital-tasks-card.component.scss',
  standalone: false,
})
export class HospitalTasksCardComponent {
  @Input() pastDueTasks: HospitalDashboardTask[] = [];
  @Input() upcomingTasks: HospitalDashboardTask[] = [];
  @Input() isLoading = false;
  @Input() readOnly = false;

  @Output() addTask = new EventEmitter<void>();
  @Output() viewAll = new EventEmitter<void>();
  @Output() openTask = new EventEmitter<number>();
  @Output() taskToggled = new EventEmitter<HospitalDashboardTask>();

  pastDueOpen = true;
  upcomingOpen = false;

  toggleTask(task: HospitalDashboardTask, event: Event): void {
    if (this.readOnly) {
      event.preventDefault();
      (event.target as HTMLInputElement).checked = false;
      return;
    }
    const checked = (event.target as HTMLInputElement)?.checked;
    if (checked) {
      this.taskToggled.emit(task);
    }
  }

  onAddTask(): void {
    if (this.readOnly) {
      return;
    }
    this.addTask.emit();
  }
}